export default "__VITE_ASSET__D$uG1rRY__"